"use client";

import { PromptInputButton } from "@/components/ai-elements/prompt-input";
import { BrainIcon } from "@/components/ui/brain";
import { supportsExtraHighChatEffort, type ChatEffort } from "@/lib/chat-effort";

export function ChatEffortControl({
  modelId,
  value,
  onChange,
}: {
  modelId: string;
  value: ChatEffort;
  onChange: (value: ChatEffort) => void;
}) {
  const supported = supportsExtraHighChatEffort(modelId);
  const extraHigh = supported && value === "xhigh";
  const label = extraHigh ? "Extra high" : "Default";

  return (
    <PromptInputButton
      aria-label={`Thinking: ${label}`}
      aria-pressed={extraHigh}
      aria-disabled={!supported}
      tooltip={{ content: supported ? `Thinking: ${label}` : "Thinking: Default — extra high unavailable for this model", side: "top" }}
      onClick={() => { if (supported) onChange(extraHigh ? "default" : "xhigh"); }}
      className="text-muted-foreground"
    >
      <BrainIcon size={16} className={extraHigh ? "text-activated" : "text-muted-foreground"} />
    </PromptInputButton>
  );
}
